module.exports = __webpack_public_path__ + "static/media/pe.cafa9d1e.png";